export default function schemaPlace(placeData) {
  const place = {
    city: "",
    region: "",
    country: "",
  };

  const regions = [];

  const hasPlaceAncestry = (
    placeData &&
    placeData.ancestry &&
    placeData.ancestry.length
  );

  if (!hasPlaceAncestry) {
    place[placeData.placeType] = placeData.name;

    return place;
  }

  placeData.ancestry.forEach((p) => {
    if (p.placeType === "region") {
      regions.push(p.name);
    } else {
      place[p.placeType] = p.name;
    }
  });

  if (regions.length) {
    place.region = regions[0];
  }

  if (placeData.placeType === "city" && !place.city) {
    place.city = placeData.name;
  }

  if (placeData.placeType === "region" && !place.region) {
    place.region = placeData.name;
  }

  if (placeData.placeType === "country" && !place.country) {
    place.country = placeData.name;
  }

  return place;
}



// WEBPACK FOOTER //
// ./assets/pois/utils/schemaPlace.js